module.exports = __webpack_public_path__ + "static/img/authInstructions_page.b250002f.png";